import { formatAuditPrice } from './formatAuditPrice'
import { formatAuditSource } from './formatAuditSource'

export const LEGACY_PRICE_FROM_PREFIX = 'Previous price:'

export const formatAuditChangedBy = changedBy => {
  const trimmed = typeof changedBy === 'string' ? changedBy.trim() : ''
  if (!trimmed || trimmed === 'unknown') return 'Unknown'
  return trimmed
}

const hasAuditPrice = value => value != null && value !== ''

const isUnknownAuditValue = value => {
  const trimmed = typeof value === 'string' ? value.trim() : ''
  return !trimmed || trimmed === 'unknown'
}

/** Pre-audit row: only a former price was stored, not a from→to pair. */
export const isLegacyPriceOnlyEntry = entry =>
  Boolean(
    entry && hasAuditPrice(entry.formerPrice) && !hasAuditPrice(entry.newPrice),
  )

/** Pre-audit row: who/source were not recorded. */
export const isLegacyAuditMetaEntry = entry =>
  Boolean(
    entry &&
      (isUnknownAuditValue(entry.changedBy) ||
        isUnknownAuditValue(entry.source)),
  )

export const isLegacyPriceHistoryEntry = entry =>
  isLegacyPriceOnlyEntry(entry) || isLegacyAuditMetaEntry(entry)

/** From column: full change pair, or legacy single formerPrice. */
export const getAuditFromPrice = entry => {
  if (!entry) return '—'
  if (hasAuditPrice(entry.newPrice) && hasAuditPrice(entry.formerPrice)) {
    return formatAuditPrice(entry.formerPrice)
  }
  if (isLegacyPriceOnlyEntry(entry)) {
    return `${LEGACY_PRICE_FROM_PREFIX} ${formatAuditPrice(entry.formerPrice)}`
  }
  return '—'
}

/** To column: new price when recorded, otherwise em dash. */
export const getAuditToPrice = entry => {
  if (!entry || !hasAuditPrice(entry.newPrice)) return '—'
  return formatAuditPrice(entry.newPrice)
}

export const sortPriceHistoryNewestFirst = (priceHistory = []) =>
  [...priceHistory].sort((a, b) => {
    const aTime = a?.updatedAt ? new Date(a.updatedAt).getTime() : 0
    const bTime = b?.updatedAt ? new Date(b.updatedAt).getTime() : 0
    return bTime - aTime
  })

export const buildPriceAuditTableRows = (priceHistory = []) =>
  sortPriceHistoryNewestFirst(priceHistory).map((entry, index) => ({
    key: entry._id || entry.id || `price-history-${index}`,
    updatedAt: entry.updatedAt,
    fromPrice: getAuditFromPrice(entry),
    toPrice: getAuditToPrice(entry),
    changedBy: formatAuditChangedBy(entry.changedBy),
    source: formatAuditSource(entry.source),
    isLegacyPrice: isLegacyPriceOnlyEntry(entry),
    isLegacyAudit: isLegacyAuditMetaEntry(entry),
    isLegacy: isLegacyPriceHistoryEntry(entry),
  }))
